export type RequirementTranslation = {
  message: string;
  type: 'required' | 'invalid';
};

export type RequirementMap = Record<RequirementCode, RequirementTranslation>;

export type InvalidRequirement = RequirementTranslation;

export const requirementCodes = [
  'requires_selected_physical_address',
  'requires_physical_address',
  'requires_valid_address',
  'requires_payment_method',
  'requires_valid_payment_method',
  'requires_selected_payment_method',
] as const;

export type RequirementCode = (typeof requirementCodes)[number];

export const TRANSLATION_MAP: RequirementMap = {
  requires_valid_address: {
    type: 'invalid',
    message:
      'Selected address is not complete. Please edit and complete the required fields to continue.',
  },
  requires_selected_physical_address: {
    type: 'required',
    message: 'You currently have not selected an address. Please choose a delivery address.',
  },
  requires_physical_address: {
    type: 'required',
    message: 'You currently have no saved addresses. Please add a delivery address.',
  },
  requires_selected_payment_method: {
    type: 'required',
    message: 'You have not selected a payment method. Please choose a payment method.',
  },
  requires_payment_method: {
    type: 'required',
    message: 'You currently have no saved cards. Please add a payment method.',
  },
  requires_valid_payment_method: {
    type: 'invalid',
    message: 'Selected payment method is invalid. Please add a new payment method.',
  },
};
